// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
// Services
import { SystemApiService } from '@cv-invision/core';
// Models
import { OrganizationModel } from '../model/create-order-form.model';
// Others
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CreateOrderService {
	constructor(
		private httpClient: HttpClient,
		private systemApiService: SystemApiService) { }

	/**
	 * Sends a request to create a new QC Order using the provided form data.
	 * The formData should include:
	 * - form
	 * - schema
	 * - product (only if generic pdf is selected)
	 * - organizationId
	 * - externalId
	 * - file (XML)
	 * - optionally, engagementLetterFile
	 *
	 * @param formData The FormData object containing order creation fields and files
	 * @returns Observable emitting the API response with the created order ID
	 */
	public createOrder(formData: FormData): Observable<any> {
		return this.httpClient.post(
			this.systemApiService.api['intelligenceService'] + 'orders/review',
			formData
		).pipe(
			map((payload: any) => payload)
		);
	}

	/**
	 * Fetches a list of available organizations from the Identity System service.
	 *
	 * @returns Observable emitting an array of mapped OrganizationModel objects
	 */
	public getOrganizations(nameFilter?: string) {
		let params: HttpParams = new HttpParams();
		if (nameFilter) {
			params = params.set('Name', nameFilter);
		}
		return this.httpClient.get(`${this.systemApiService.api['identitySystemService']}classvaluation/organizations`, {params}).pipe(
			map((response: any) => {
				let organizations: OrganizationModel[] = [];

				if (response?.data?.length) {
					organizations = response.data.map((organization) => {
						const organizationObj: OrganizationModel = {
							id: organization.id ?? '',
							name: organization.name ?? '',
						};
						return organizationObj;
					});
				}
				return organizations;
			})
		);
	}
}
